import Dialog from "../../../atoms/dialog";
import DeleteViewEntity from '../../dashboardBuilder/DeleteViewEntity';


const DeleteItemAlert = (props) => {
    const { id, parentID, type, onClose, selectedView, dashboardInstance } = props;

    const handleClose = () => {
        onClose();
    }

    return (
        <Dialog
            title={"Delete"}
            open={true}
            handleClose={handleClose}
        >
            <DeleteViewEntity id={id} dashboardInstance={dashboardInstance} parentID={parentID} selectedView={selectedView} type={type} onClose={onClose} />
        </Dialog >
    )

}

export default DeleteItemAlert;